import { useCallback, useEffect, useMemo, useState } from 'react';
import { keyBy } from '@shared/functions';
import { CamerasMaps, camerasMapGetAPI } from 'api/cameras';

/**
 * カメラ一覧とカメラに紐づくマップID一覧を取得するcustom hooks
 */
export const useCamerasMap = () => {
  const [cameras, setCameras] = useState<CamerasMaps[] | undefined>(undefined);
  const cameras_record: Record<string, CamerasMaps> = useMemo(() => {
    return cameras ? keyBy(cameras, (d) => String(d.camera_id)) : {};
  }, [cameras]);
  const loadCameras = useCallback(async () => {
    setCameras(undefined);
    const res = await camerasMapGetAPI();
    if (res.status === 200) {
      setCameras(res.data);
    } else {
      setCameras([]);
    }
  }, []);

  useEffect(() => {
    loadCameras();
  }, [loadCameras]);

  return useMemo(() => {
    return {
      cameras,
      cameras_record,
      setCameras,
      loadCameras,
    };
  }, [cameras, cameras_record, setCameras, loadCameras]);
};
